<template>
  <div class="d-flex flex-column align-items-center bg-white px-4 px-md-5 py-5 w-100" style="max-width: 720px">

    <b-row class="w-100 mb-4">
      <b-col md="3">
        <img src="https://wallkit.net/svg/sygnet.svg" alt="Logo" width="100" class="mx-auto d-block mb-2 mb-md-0">
      </b-col>
      <b-col class="text-left">
        <h3 class="font-weight-light">Checkout with Wallkit</h3>
        <p class="text-muted">Choose from any one of our options below.</p>
      </b-col>
    </b-row>

    <b-row class="w-100 mb-4">
      <b-col class="text-left">
        <h5>Plan Title</h5>
        <p class="mb-0">Plan description</p>
      </b-col>
      <b-col class="text-left">
        <p><b>$295.00</b> for 1 year</p>
      </b-col>
      <b-col md="3">
        <b-button class="w-100 mt-2 mt-md-0" variant="primary">Choose</b-button>
      </b-col>
    </b-row>

    <b-row class="w-100 mb-4">
      <b-col class="text-left">
        <h5>Plan Title</h5>
        <p class="mb-0">Plan description</p>
      </b-col>
      <b-col class="text-left">
        <p><b>$295.00</b> for 1 year</p>
      </b-col>
      <b-col md="3">
        <b-button class="w-100 mt-2 mt-md-0" variant="primary">Choose</b-button>
      </b-col>
    </b-row>

    <b-row class="w-100">
      <b-col class="text-left">
        <h5>Plan Title</h5>
        <p class="mb-0">Plan description</p>
      </b-col>
      <b-col class="text-left">
        <p><b>$295.00</b> for 1 year</p>
      </b-col>
      <b-col md="3">
        <b-button class="w-100 mt-2 mt-md-0" variant="primary">Choose</b-button>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  export default {
    name: 'subscribePopup'
  }
</script>